import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AttractorTimeout from '../../warning/attractorTimeout';

const IntroductionPuzzleScreen = ({ config, gameData, passRefUpward}) => {

    AttractorTimeout(config, passRefUpward);

    useEffect(() => {
        const playData = [];
        window.sessionStorage.setItem('playData', JSON.stringify(playData));
    }, [])


    return (
        <div className='introductionScreen puzzle-screens'>
            <p className="intro-text">{ config.screens.introductionScreen.text }</p>

            <div className='App__button-large-container'>
                <button>
                    <Link to={`/executables/${gameData.gameClass}/attractor`} >{config.screens.introductionScreen.start_link_text}</Link>
                </button>
            </div>
        </div>
    );
};

export default IntroductionPuzzleScreen;
